<template>
    <Input v-model="inputV2" @on-blur="blurPrice()" @input.native="(e)=>{changePrice(e)}" @input="callback" />
</template>
<script>
import {floatPoint} from '@/libs/fn.js';
import filter from '@/libs/filter.js';
export default {
	name: 'myInput',
	props: {
        formModel:{
			type: [String,Number],
			default:'' 
		},
	},
	data() {
		return {
            inputV2:this.formModel,
		}
    },
	created(){	
    },
    watch:{
        formModel(v){
            this.inputV2 = v;
        }
    },
	computed: {
	},
	methods: {
        changePrice(e){
            if(e.target.value.indexOf(",")>0)e.target.value = e.target.value.replace(/,/gi,'');
            e.target.value = (e.target.value.match(/^\d*(\.?\d{0,2})/g)[0])||null
            this.inputV = e.target.value;
            this.inputV2 = e.target.value;
            console.log(this.inputV)
            console.log(this.inputV2)
            // var num = floatPoint(this.everySum[i],item.ec_use_amt,'-');
            // item.maxbillamt = num > 0 ? num : '0';
        },
        blurPrice(){
            // if(list.ec_use_amt2.toString().indexOf(",")>0)list.ec_use_amt2 = list.ec_use_amt2.replace(/,/gi,'');
            // this.$emit('watchPrice',{data:list,parentIndex:this.index,childIndex:i})
            // list.ec_use_amt2 = list.ec_use_amt2?filter.formatMoney(list.ec_use_amt2):'';
            this.inputV2 = this.inputV2?filter.formatMoney(this.inputV2):'';
        },
        callback(){
            this.$emit('callback',this.inputV2);
            // if(item.ec_use_amt2>everySum[index]){item.ec_use_amt2='';}
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/inc/component/myInput.vue